// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, anyOf } from "@altostra/type-validations";
import { boolean, number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

const nullableNumber = anyOf(number, nullValidation);
const nullableString = anyOf(string, nullValidation);

export const isRecommendedUserItem = objectOf({
  product_id: string,
  nst: string,
  sample_users: number,
  estimated_users_rate: number,
  estimated_users: number,
});

export const isRecommendedUserItems = objectOf({
  sample_users: number,
  sample_personalized_rate: number,
  sample_most_popular_rate: number,
  estimated_personalized_users: number,
  estimated_most_popular_users: number,
  items: arrayOf(isRecommendedUserItem),
});

export const isEngagementRecommenderAnalytics = objectOf({
  coverage: maybe(number),
  precision: maybe(number),
  most_popular_items: arrayOf(string),
  trending_items: arrayOf(string),
  recommended_user_items: isRecommendedUserItems,
  n_catalog_items: number,
  event_name: maybe(nullableString),
  lookback_days: maybe(nullableNumber),
  total_population: maybe(nullableNumber),
  eligible_users: maybe(nullableNumber),
  personalized_users: maybe(nullableNumber),
  personalization_rate: maybe(nullableNumber),
  degraded: maybe(boolean),
});
